import { Injectable } from '@angular/core'
import { DocumentSpace } from '@awork/features/document/models/document-space.model'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'

@Injectable({ providedIn: 'root' })
export class DocumentSpaceStore extends EntitySignalStore<DocumentSpace> {
  constructor() {
    super({
      name: 'documentSpace',
      entityConstructor: documentSpace => new DocumentSpace(documentSpace),
      persistActiveState: false,
      nullableProps: ['order']
    })
  }
}
